import RestModule from "../RestModule";

export default new RestModule("invoices", {
  empty: {
    bill_items: [],
    period: "",
  },
  rules: {},
});
